import { Typography } from '@mui/material'
import React from 'react'

import Button from '@/components/Button'
import Dialog from '@/components/Dialog'

interface DailyLimitModalProps {
  message: string | null
  onClose: () => void
}

const DailyLimitModal: React.FC<DailyLimitModalProps> = ({
  message,
  onClose,
}) => {
  if (!message) return null

  return (
    <Dialog
      triggerElement={null}
      isOpen={!!message}
      onClose={onClose}
      title="Daily Limit Reached"
      content={<Typography>{message}</Typography>}
      actionButtons={
        <Button
          variant="contained"
          label="OK"
          onClick={onClose}
          textTransform="uppercase"
        />
      }
    />
  )
}

export default DailyLimitModal
